import { render, staticRenderFns } from "./BatchPassDialog.vue?vue&type=template&id=3ed36626&scoped=true"
import script from "./BatchPassDialog.vue?vue&type=script&lang=js"
export * from "./BatchPassDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchPassDialog.vue?vue&type=style&index=0&id=3ed36626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed36626",
  null
  
)

export default component.exports